let initialized = false;
let FB;

const FBHelper = {
    init(appId, version) {
        FB = window.FB;

        if (typeof FB !== 'undefined') {
          FB.init({appId, version});

          initialized = true;
        }
    },

    share(href, quote) {
        if (!initialized) {
            throw new Error('FB API haven\'t initialized yet');
        }

        FB.getLoginStatus(response => {
            if (response.status === 'connected') {
                FB.ui({method: 'share', href, quote});
            } else {
                FB.login(response => {
                    if (response.authResponse) {
                        FB.ui({method: 'share', href, quote});
                    }
                });
            }
        });
    }
}

export default FBHelper;



// WEBPACK FOOTER //
// ./app/src/utils/misc/FBHelper.js